import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12 xl:col-8" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = {
  key: 0,
  class: "col-12 xl:col-8"
}
const _hoisted_5 = {
  key: 1,
  class: "col-12 xl:col-8"
}
const _hoisted_6 = { class: "grid justify-content-between" }
const _hoisted_7 = { class: "col-10 flex align-items-center pb-0" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "flex align-items-center mb-2" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "flex align-items-center" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "col-2 flex align-items-center justify-content-end pb-0" }
const _hoisted_14 = {
  key: 1,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: _ctx.$t('conflicts'),
      "show-refresh-button": _ctx.conflictsFetched,
      "refresh-button-loading": _ctx.conflictsLoading,
      "refresh-button-handler": _ctx.fetchConflicts
    }, null, 8, ["title", "show-refresh-button", "refresh-button-loading", "refresh-button-handler"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PrimeVueMessage, {
          severity: "info",
          closable: false
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "ml-3" }, "В данном списке выводятся конфликты между эндпоинтами и фидами.", -1),
            _createElementVNode("div", { class: "ml-3" }, "Если эндпоинт имеет белый список по фидам и этот список содежит фид, который в свою очередь имеет белый список по эндпоинтам, но не содержит в этом списке данный эндпоинт, то возникает конфликт и трафик на фид идти не будет.", -1),
            _createElementVNode("div", { class: "ml-3" }, "Для решения конфликта необходимо добавить эндпоинт в белый список фида или удалить фид из белого списка эндпоинта. 🤯", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.conflictsLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_PrimeVueSkeleton, { height: "30px" })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.conflicts.data.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.conflicts.data, (conflict, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["card mb-3", { 'processed': conflict.processed }]),
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", null, "🚨", -1)),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_IconPark, {
                              class: "mr-2",
                              type: "link-in",
                              theme: "outline",
                              size: "14"
                            }),
                            _createElementVNode("a", {
                              href: `/endpoints/${conflict.endpoint_id}`,
                              target: "_blank"
                            }, _toDisplayString(conflict.endpoint.compiled_name), 9, _hoisted_10)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_IconPark, {
                              class: "mr-2",
                              type: "file-quality-one",
                              theme: "outline",
                              size: "14"
                            }),
                            _createElementVNode("a", {
                              href: `/feeds/${conflict.feed_id}`,
                              target: "_blank"
                            }, _toDisplayString(conflict.feed.compiled_name), 9, _hoisted_12)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createVNode(_component_PrimeVueButton, {
                          class: "p-button-rounded p-button-text p-button-success",
                          icon: "pi pi-plus",
                          loading: conflict.loadingAdd,
                          onClick: ($event: any) => (_ctx.addEndpointToFeedWhitelist(conflict.endpoint_id, conflict.feed_id, index))
                        }, null, 8, ["loading", "onClick"]), [
                          [
                            _directive_tooltip,
                            _ctx.$t('add_endpoint_to_feed_whitelist'),
                            void 0,
                            { left: true }
                          ]
                        ]),
                        _withDirectives(_createVNode(_component_PrimeVueButton, {
                          class: "p-button-rounded p-button-text p-button-danger",
                          icon: "pi pi-times",
                          loading: conflict.loadingDelete,
                          onClick: ($event: any) => (_ctx.deleteFeedFromEndpointWhitelist(conflict.feed_id, conflict.endpoint_id, index))
                        }, null, 8, ["loading", "onClick"]), [
                          [
                            _directive_tooltip,
                            _ctx.$t('delete_feed_from_endpoint_whitelist'),
                            void 0,
                            { right: true }
                          ]
                        ])
                      ])
                    ])
                  ], 2))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('nothing')), 1))
          ]))
    ])
  ], 64))
}